import React from "react"
import { SSRProvider } from "react-bootstrap";

export const wrapPageElement = ({ element }) => {
  return (
    <SSRProvider>
      {element}
    </SSRProvider>
  )
}